import PropTypes from 'prop-types'

import {PLACEMENTS, Tooltip, TooltipContent, TooltipTrigger} from '@adv-mt/ui/tooltip'

// The trigger renders a span: the wrapped actions are already buttons, and TooltipTrigger defaults to one.
const ActionTooltip = ({label, children}) => (
  <Tooltip>
    <TooltipTrigger render={<span />}>{children}</TooltipTrigger>
    <TooltipContent placement={PLACEMENTS.BOTTOM}>{label}</TooltipContent>
  </Tooltip>
)

ActionTooltip.displayName = 'ActionTooltip'
ActionTooltip.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default ActionTooltip
